'use strict';

angular.module('AcaApp').controller('FilesListRFMController',
[
  '$scope',
  '$filter',
  '$mdDialog',
  '$window',
  'LayoutService',
  'RFMService',
  'UtilsService',
  'LockedScreenService',
  function($scope, $filter, $mdDialog, $window, LayoutService, RFMService, UtilsService, LockedScreenService){
    $scope.isArrayFormatted = false;
    LockedScreenService.disableAutomaticOpenWindow();
    LayoutService.addFloatLayer('#filter', '#layer-filter');
    $scope.token = $window.sessionStorage.token;
    $scope.propertyName = 'createdon';
    $scope.reverse = true;
    this.startParams = function(){
      $scope.filterFiles = {};
      $scope.filterFilesType('All Files');
      $scope.filesFiltered = {};
      $scope.getFilesList();
    };

    $scope.getFilesList = function(){
      RFMService.getFilesListRFM().then(function(data){
        $scope.filesList = UtilsService.convertToKB(data.result);
        $scope.filesList = _.each($scope.filesList, function(element){
          element.type = (element.type === 'XMIT') ? 'TRANSMITTAL' : element.type;
        });
        orderChangeByDate();
        $scope.nextRecords = (data.result.length > 0) ? true : false;
      });
    };

    $scope.uploadDirective = {
      token: $window.sessionStorage.token,
      onSuccess: function(){
        $scope.getFilesList();
      },
      onError: function(){
      }
    };

    $scope.showTypes = [
      {Type: 'All Files'},
      {Type: 'Report'},
      {Type: 'Export'},
      {Type: 'Import'},
      {Type: 'Print'},
      {Type: 'Print Preview'},
      {Type: 'Transmittal'},
      {Type: 'User Upload'}
      ];

    $scope.onOrderChange = function(propertyName){
      $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
      if ($scope.propertyName === "createdon" || $scope.propertyName === "expiredate"){
        orderChangeByDate();
      }
      else{
        $scope.filesList = $filter('orderBy')($scope.filesList, $scope.propertyName, $scope.reverse);
      }
      return $scope.filesList;
    };

    var orderChangeByDate = function(){
      $scope.filesList.sort(function(a, b){
          if ($scope.reverse){
            return new Date(b[$scope.propertyName]).getTime() - new Date(a[$scope.propertyName]).getTime();
          }
          else{
            return new Date(a[$scope.propertyName]).getTime() - new Date(b[$scope.propertyName]).getTime();
          } 
      });
    };

    $scope.filterFilesType = function(fileType){
      if(fileType === 'All Files'){
        $scope.filterFiles.fileType = fileType;
        $scope.filterFiles.filterByType = '';
      }
      else{
        $scope.filterFiles.fileType = fileType;
        $scope.filterFiles.filterByType = fileType;
      }
    };
    $scope.filterFilesByName = function(search){
      $scope.filterFiles.filterByName = search;
    };
    $scope.getUnixTimestamp = function(date){
      return UtilsService.getUnixTimestamp(date);
    };

    $scope.deleteFile = function(){
      RFMService.deleteFile($scope.selectedFileRealname).then(function(){
        $scope.getFilesList();
        $mdDialog.hide();
      });
    };

    $scope.showConfirm = function(event, showname, fileRealname){
      $scope.selectedFile = showname;
      $scope.selectedFileRealname = fileRealname;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/filesListRFM/modals/delete_file.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };
    $scope.closeModal = function(){
      $mdDialog.hide();
    };
    this.startParams();
  }
]);
